import React, {useState} from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {useSetTimeout} from 'app/utils/hooks';

import StateButton, {type Props as StateButtonProps} from './StateButton';

interface Props extends StateButtonProps {
  duration: number; // seconds
  delayTooltip: string;
  isResponseSuccessful: (response: any) => boolean;
}

export function DelayButton({
  duration,
  children,
  disabled,
  delayTooltip,
  isResponseSuccessful,
  onClick,
  ...other
}: Props): JSX.Element {
  const [isDelayed, setIsDelayed] = useState(false);
  const setTimeout = useSetTimeout();

  function startDelay(e: React.MouseEvent<unknown>) {
    setTimeout(() => setIsDelayed(false), duration * 1000);
    const maybePromise: void | Promise<any> = onClick(e);
    return maybePromise?.then(
      (response) => isResponseSuccessful(response) && setIsDelayed(true)
    );
  }

  return (
    <LazyTooltip hide={!isDelayed} tooltip={delayTooltip}>
      <StateButton
        disabled={isDelayed || disabled}
        onClick={startDelay}
        {...other}
      >
        {children}
      </StateButton>
    </LazyTooltip>
  );
}
